import { useState } from "react";
import { authApi, messageFrom } from "../api";
import Packages from "./Packages";

function Login({ onLoggedIn }) {
    const [form, setForm] = useState({ username: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        if (!form.username || !form.password) {
            setError("Enter your username and password");
            return;
        }
        setError("");
        setLoading(true);
        authApi
            .login(form.username, form.password)
            .then(() => onLoggedIn())
            .catch((err) => setError(messageFrom(err, "Login failed")))
            .finally(() => setLoading(false));
    };

    return (
        <div className="landing">
            <header className="landing__nav" style={{padding: "0 0 0 30px !important"}}>
                <div className="brand">
                    <span className="brand__mark">CF</span>
                    <span className="brand__name">Carfax Reports</span>
                </div>
            </header>

            <div className="landing__hero">
                <div className="hero__copy">
                    <h1>Instant vehicle history reports</h1>
                    <p>Enter a VIN and pull a full CARFAX report in seconds. Trusted data for dealers and importers.</p>
                </div>

                <form className="auth-card" onSubmit={submit}>
                    <h2>Sign in</h2>
                    {error && <div className="auth-card__error">{error}</div>}
                    <label className="field">
                        <span>Username</span>
                        <input
                            autoComplete="username"
                            value={form.username}
                            onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))}
                        />
                    </label>
                    <label className="field">
                        <span>Password</span>
                        <input
                            type="password"
                            autoComplete="current-password"
                            value={form.password}
                            onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
                        />
                    </label>
                    <button className="btn btn--primary" type="submit" disabled={loading}>
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>

            <Packages />

            <footer className="landing__footer">
                <span>© {new Date().getFullYear()} Carfax Reports</span>
            </footer>
        </div>
    );
}

export default Login;
